const FormResources = {

    form_data:{
        name:                   '',
        description:            '',
        production_standard:    '',
        zone:                   '',
        policing:               false,
        unit:                   false,
        project:                false,
        step_code_id:           [],
        special_task_type:      '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Cleaning Code:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  500,
            disabled:   false,
            step:       'any',
            name:       'Production standard:',
            model_name: 'production_standard',
            ref:        'production_standard_input',
            ref_alt:    'production_standard_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Task type:',
            model_name: 'special_task_type',
            ref:        'special_task_type_input',
            ref_alt:    'special_task_type_input_alt',
            empty_option_name: 'Daily',
            required:   false,
        },
        // {
        //     css_class:  'col-md-4',
        //     type:       'checkbox',
        //     maxlength:  '',
        //     disabled:   false,
        //     step:       '',
        //     name:       'Policing:',
        //     model_name: 'policing',
        //     ref:        'policing_input',
        //     ref_alt:    'policing_input_alt',
        //     required:   false,
        // },
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Units:',
            model_name: 'unit',
            ref:        'unit_input',
            ref_alt:    'unit_input_alt',
            required:   false,
        },
        // {
        //     css_class:  'col-md-4',
        //     type:       'checkbox',
        //     maxlength:  '',
        //     disabled:   false,
        //     step:       '',
        //     name:       'Project:',
        //     model_name: 'project',
        //     ref:        'project_input',
        //     ref_alt:    'project_input_alt',
        //     required:   false,
        // },
        // {
        //     css_class:  'col-md-12',
        //     type:       'select-multiple',
        //     maxlength:  '',
        //     disabled:   false,
        //     step:       '',
        //     name:       'Step Codes:',
        //     model_name: 'step_code_id',
        //     ref:        'step_code_id_input',
        //     ref_alt:    'step_code_id_input_alt',
        //     required:   false,
        // },
    ],

}

export default FormResources;